import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CompaniesService, Company } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { ImgDisplayComponent } from '../img-display/img-display.component';

@Component({
    selector: 'app-company-logo-association',
    templateUrl: './company-logo-association.component.html',
    styleUrls: ['./company-logo-association.component.scss'],
    standalone: true,
    imports: [ImgDisplayComponent, FileUploadComponent, TranslateModule]
})
export class CompanyLogoAssociationComponent implements OnInit, OnDestroy {
  @Input() company: Company;

  isLoadingUpload = false;
  updateSub = new Subscription();
  logoTs: string;

  // uploadFile
  backendResponseUploadedFile: any = null;

  constructor(private companiesService: CompaniesService) {}

  ngOnInit(): void {
    this.logoTs = this.company.logoTs;
  }

  ngOnDestroy(): void {
    this.updateSub.unsubscribe();
  }

  onUserWantsUploadEvent(file: File): void {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const blob = new Blob([new Uint8Array(e.target.result)], { type: file.type });
        this.uploadFile(blob);
      };
      reader.readAsArrayBuffer(file);
    }
  }

  // ---------------------------------------- //
  //                   APIS                   //
  // ---------------------------------------- //
  uploadFile(file: Blob): void {
    this.isLoadingUpload = true;
    this.updateSub = this.companiesService.updateCompanyLogo(this.company.uid, file).subscribe({
      next: (response: Blob) => {
        this.isLoadingUpload = false;
        this.backendResponseUploadedFile = { status: '200' };
        this.logoTs = Date.now().toString();
      },
      error: (err) => {
        this.isLoadingUpload = false;
        this.backendResponseUploadedFile = err;
      }
    });
  }
}
